module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-100.3f09764c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-100.png
// module id = 3291
// module chunks = 11